<template>
    <div class="crowdDetails pages">
       
        <div class="content">
            <div class="f1" style="padding-bottom:1px;">
                <div class="title mb-30">
                    <p>
                        <img src="../../assets/images/newIcon/margetmiddleadd_basicsetup_icon.png" alt="">
                        <span>基本设置</span>
                    </p>
                    <p>
                    </p>
                </div>
                <div class="leveCent">
                <el-form ref="form" :model="form" label-width="120px" size="mini">
                    <el-form-item label="会员名称：" prop="name" :rules="{
                    required: true, message: '请输入会员名称', trigger: 'blur'
                    }">
                        <el-input v-model="form.name" maxlength="8" placeholder="请输入1-8字会员名称"></el-input>
                    </el-form-item>
                    <el-form-item label="会员等级：" prop="" :rules="{
                    required: true
                    }">
                          <el-select v-model="value" placeholder="请选择会员等级">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                     <!-- <p class="tips" style="padding-bottom:0;"><i>*</i> 每次推送人数建议少于10万，否则容易出现延时的情况</p> -->
                    </el-form-item>
                     <el-form-item label="等级背景：" prop="name" :rules="{
                    required: true, message: '请输入会员名称', trigger: 'blur'
                    }">
                    <el-popover
                    v-model="isColor"
                    placement="bottom"
                    width="290"
                    trigger="click">
                       <p class="colorL">
                           <span @click="cks(i)" v-for="(t,i) in colorList" :key="i" :style="{background:t}"></span>
                       </p>
                        <p slot="reference" class="selectBG">
                            <span :style="{background:colorList[bgCk]}"></span>
                        </p>
                    </el-popover>
                      
                        <!-- <el-color-picker v-model="color1"></el-color-picker> -->
                    </el-form-item>
                    <el-form-item :style="'margin-bottom:20px;'" style="positon:relative;" label="获得条件：" class="jihua" :rules="{required: true}">
                        <p class="tips mb-15" style="padding:0;">修改等级所需成长值后，部分客户会因无法达到该成长值要求而发生会员等级的变化</p>
                        <el-radio-group v-model="form.radtype">
                            <div class="czz mb-15">
                                <el-radio label="1">成长值</el-radio>
                                 <el-input v-model="form.name2" maxlength="8" placeholder="请输入会员所需成长值"></el-input>
                            </div>
                           <div class="czz">
                               <el-radio label="2">积分</el-radio>
                                <el-input v-model="form.name3" maxlength="8" placeholder="请输入会员所需积分"></el-input>
                           </div>
                            
                        </el-radio-group>
                        
                    </el-form-item>
                    <el-form-item class="chufa" label="业务系统：" :rules="{required: true}">
                        <el-select v-model="value2" placeholder="请选择业务系统">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div class="leveS" :style="`background-size: 100% 100%;background:url(${imgList[bgCk]}) no-repeat;`">
                   <p>黄金会员</p>
                   <p class="ts">仅为预览效果，实际以用户查看时为准</p>
                </div>
                </div>
            </div>
            <div class="f2" style="padding-top:1px;">
                 <div class="title mb-30">
                    <p>
                        <img src="../../assets/images/newIcon/margetmiddleadd_rightsset_icon.png" alt="">
                        <span>权益设置</span>
                    </p>
                    <p>
                    </p>
                </div>
                <el-form ref="form" :model="form" label-position="right" label-width="120px" size="mini">
                     <el-form-item class="chufa" label="权益设置：" :rules="{required: true}">
                         <p class="tips" style="padding-top:0;">修改权益设置后，不影响之前已获得该权益的用户</p>
                        <!-- <el-radio-group v-model="form.type">
                                <el-radio label="1">
                                </el-radio>
                        </el-radio-group> -->
                        <el-checkbox-group v-model="checkList">
                            <el-checkbox label="1">虚拟权益</el-checkbox>
                        </el-checkbox-group>
                        <div class="xuni">
                            <el-form ref="form" :model="form" label-width="80px" size="mini">
                                <el-form-item label="图标：" prop="name">
                                    <el-upload
                                        class="avatar-uploader"
                                        action="https://jsonplaceholder.typicode.com/posts/"
                                        :show-file-list="false"
                                        :on-success="handleAvatarSuccess"
                                        :before-upload="beforeAvatarUpload">
                                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                     <p class="tips mb-15" style="padding:0;"><i>*</i> 请按尺寸上传png/jpg格式且小于2M的图片</p>
                                </el-form-item>
                                <el-form-item label="名称：" prop="">
                                      <el-input type="" v-model="form.name4" maxlength="8" placeholder="请输入虚拟权益名称"></el-input>
                                <!-- <p class="tips" style="padding-bottom:0;"><i>*</i> 每次推送人数建议少于10万，否则容易出现延时的情况</p> -->
                                </el-form-item>
                                <el-form-item label="描述：" prop="name">
                                    <el-input
                                    type="textarea"
                                    :rows="6"
                                    resize="none"
                                    placeholder="请输入内容"
                                    v-model="textarea">
                                    </el-input>
                                   
                                </el-form-item>
                            </el-form>
                        </div>
                        <div style="display:flex;margin-top:15px;">
                            <el-checkbox-group v-model="checkList">
                            <el-checkbox label="2">优惠券</el-checkbox>
                            
                            </el-checkbox-group>
                            <p style="margin-left:10px;"><el-button @click="addCoupon" type="primary" icon="el-icon-plus">添加优惠券</el-button></p>
                        </div>
                        
                        <!-- <el-radio-group v-model="form.type">
                                <div class="addyhq">
                                    <el-radio label="2">优惠券
                                    </el-radio>
                                  
                                </div>
                        </el-radio-group> -->
                       
                        <div style="margin-left:25px;">
                            <div class="tabTitle">
                                <p>共<span>100</span>条 已选中<span>0</span>条</p>
                                <el-button @click="del" round icon="el-icon-delete">批量删除</el-button>
                            </div>
                            <el-table
                                :data="tableData3"
                                :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
                                style="width: 100%;"
                                :cell-style="{textAlign: 'center',fontSize:'12px'}"
                                >
                                <el-table-column
                                type="selection"
                                width="55">
                                </el-table-column>
                                <el-table-column
                                prop="name"
                                label="优惠券名称"
                                show-overflow-tooltip
                                >
                                </el-table-column>

                                <el-table-column
                                prop="number"
                                label="类型"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="number"
                                label="业务系统"
                                
                                cell-style="background:red;"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="xmember"
                                label="内容"
                            >
                                </el-table-column>
                                <el-table-column
                                prop="lmember"
                                label="状态"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="num"
                                label="已领取"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="num"
                                label="剩余"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="num"
                                label="已使用"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="num"
                                label="操作"
                                >
                                    <template slot-scope="scope">
                                        <el-button @click="del" type="text">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                             <div class="page pageL">
                                <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                style="margin-top: 24px;"
                                :current-page="query.page_index"
                                :page-sizes="[10, 20, 30, 40]"
                                :page-size="query.page_size"
                                layout="prev, pager, next, sizes, jumper"
                                :total="total"
                                ></el-pagination>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <span  class="footer">
                <el-button class="quxiao" @click="handleClose" >取 消</el-button>
                <el-button type="primary" @click="()=>{$message({
          message: '恭喜你，保存成功',
          type: 'success'
        });}" >保 存</el-button>
            </span>
        </div>
        <selectCoupon ref="selectCoupon"></selectCoupon>
    </div>
</template>
<script>
const QUERY={
    keyword_search:"",
    page_index: 1,
    page_size: 10,
}
const yellow_bg=require('../../assets/images/leve/yellow_bg.png');
const redq_bg=require('../../assets/images/leve/redq_bg.png');
const green_bg=require('../../assets/images/leve/green_bg.png');
const greens_bg=require('../../assets/images/leve/greens_bg.png');
const blue_bg=require('../../assets/images/leve/blue_bg.png');
const blues_bg=require('../../assets/images/leve/blues_bg.png');
const red_bg=require('../../assets/images/leve/red_bg.png');
const reds_bg=require('../../assets/images/leve/reds_bg.png');
const breenq_bg=require('../../assets/images/leve/breenq_bg.png');
const godle_bg=require('../../assets/images/leve/godle_bg.png');
const zi_bg=require('../../assets/images/leve/zi_bg.png');
const goden_bg=require('../../assets/images/leve/goden_bg.png');
const gedenq_bg=require('../../assets/images/leve/gedenq_bg.png');
const grey=require('../../assets/images/leve/grey.png');
import selectCoupon from './components/selectCoupon.vue'
export default {
    data() {
        return {
            isColor:false,
            types:1,
            query:JSON.parse(JSON.stringify(QUERY)),
             total:100,
            tableData: [{
                name: '新客户人群',
                address: '129,000'
            }],
            bgCk:0,
            imgList:[yellow_bg,redq_bg,green_bg,greens_bg,blue_bg,blues_bg,red_bg,reds_bg,breenq_bg,godle_bg,zi_bg,goden_bg,gedenq_bg,grey],
            colorList:['#F8B753','#E96C50','#6BA863','#3A976A','#4DB3E8','#245EC1','#CF3F36','#C35953','#A9C560','#FFB860','#9B6FC8','#EEC153','#FFD291','#868686'],
            color1:'#F8B753',
            checkList:[],
            tableData3: [{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '6.1活动券',
                number:"折扣券",
                xmember:"业务系统",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '双11大额优惠券',
                number:"优惠券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '特大聚汇活动',
                number:"代金券",
                xmember:"业务系统",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },{
                name: '生日活动券',
                number:"满减券",
                xmember:"积分商城",
                lmember:"满99,减10",
                labellv:"发送中",
                num:"100"
                },],
            options: [{
            value: '选项1',
            
            label: '小橘帮帮'
            }, {
            value: '选项2',
            label: '颐安中台'
            }],
            value: '',
            value2: '选项1',
            form: {
                radtype:"2",
                name: '',
                name2: '',
                name3: '',
                name4: '',
                region: '',
                date1: '',
                date2: '',
                timevalue:"",
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            }
        }
    },
    components:{
        selectCoupon
    },
    methods:{
        del(){
            this.$confirm('是否确定删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
            this.$message({
                type: 'success',
                message: '删除成功!'
            });
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消删除'
            });          
            });
        },
        cks(i){
            this.bgCk=i;
            this.isColor=false;
        },
        handleClose(){
            this.$router.go(-1);
        },
        addCoupon(){
            this.$refs.selectCoupon.show();
        }
    }
}
</script>
<style lang="less" scoped>
    .title{
        display: flex;
        justify-content: space-between;
        p{
            font-size: 16px;
            font-weight: 500;
            color: #333940;
            img{
                margin-right:10px;
                width:20px;
                height:20px;
                vertical-align: middle;
                &:last-child{
                    margin-left:10px;
                    width:78px;
                    height:20px;
                }
            }
            &:last-child{
                span{
                    color: #0091FF;
                }
            }
            
        }
    }
    /deep/ .el-color-picker__trigger{
        width:58px;
        height:36px;
    }
    .footer{
        display: block;
        background: #fff;
        padding:15px 30px;
        border-top:1px solid #ededed;
        .el-button{
            border-radius: 30px;
        }
    }
    .checkTab{
        background: #fff;
        padding:60px 0;
        display: flex;
        justify-content: center;
        border-radius: 6px;
        img{
            width:28px;
            height:28px;
        }
        li{
            display: flex;
            align-items: center;
            margin-right:220px;
            position: relative;
            &:last-child{
                margin:0;
                &::after{
                    left: -206px;
                }
            }
            &:first-child{
                
                &::after{
                    display:none;
                }
                
            }
            &:nth-child(2){
                &::after{
                    left: -205px;
                }
                
            }
            
            &::after{
                content: '';
                position: absolute;
                top: 30px;
                border-bottom: 1px dashed #A7A7A7;
                width: 190px;
                height: 2px;
            }
        }
        .active{
            &::after{
                border-bottom: 1px dashed #327EFF;
            }
            p{
                &:last-child{
                    color: #327EFF;
                }
                &:first-child{
                    background: linear-gradient(180deg, #587FFB 0%, #3968FC 100%);
                    color:#fff;
                }
                span{
                    &:first-child{
                        color:#327EFF;
                    }
                    &:last-child{
                        color:#484848;
                    }
                }
            }
        }
        p{
            // text-align: center;
            &:first-child{
                margin:0 auto;
                margin-right:20px;
                width: 58px;
                height: 58px;
                border-radius: 50%;
                line-height: 63px;
                text-align: center;
                background: #EBEBEB;
                font-size: 34px;
                font-weight: 500;
                color: #fff;
            }
            &:last-child{
                font-size: 14px;
                font-weight: 400;
                color: #A1A1A1;
                span{
                    display: block;
                    color: #999990;
                    &:first-child{
                        margin-bottom:10px;
                        font-size: 20px;
                        font-weight: 500;
                        
                    }
                }
            }
        }
    }
      /deep/.el-input .el-input__inner{
                border-radius: 30px;
                background: #F6F6F6;
                border: 0px;
            }
    .content{
        .f1{
            border-radius: 6px;
            padding:30px;
            padding-bottom:100px;
            background: #fff;
           
            // .chufa{
            //     /deep/ .el-form-item__content{
            //         padding-top:10px;
            //     }
            //     .z{
            //         margin-bottom:15px;
            //         padding:15px 0;
            //         padding-left:25px;
            //         font-size: 14px;
            //         font-weight: 400;
            //         color: #666666;
            //     }
            // }
            /deep/ .el-select{
                width:100%;
            }
            .el-radio-group{
                width:100%;
            }
            .czz{
                
                display: flex;
                align-items: center;
                /deep/ .el-radio{
                    width:120px;
                    margin-right:0;
                }
            }
            .el-form{
                width:50%;
                img{
                    width:16px;
                    height:16px;
                    vertical-align: middle;
                }
            }
            // .jihua{
            //     p{
            //         span{
            //             color:#666666;
            //         }
            //         font-size: 14px;
            //         font-weight: 400;
            //         color: #000;
            //     }
            // }
            // .jihua2{
            //     .el-button{
            //          background: #DFF1FF;
            //          color:#0091FF;
            //     }
            // }
            .leveCent{
                position: relative;
            }
            .leveS{
                p{
                    padding:30px;
                    font-size: 18px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #553709;
                }
                position: absolute;
                right:0;
                top:0;
                width:412px;
                height:220px;
                background: url('../../assets/images/newIcon/yellow_bg.png') no-repeat;
                background-size:100% 100% !important;
                .ts{
                    width:100%;
                    box-sizing: border-box;
                    text-align: center;
                    position: absolute;
                    bottom:-67px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #777777;
                }
            }
        }
        .tips{
                padding:15px 0;
                font-size: 12px;
                font-weight: 400;
                color:#999;
                i{
                     color: #E02020;
                }
        }
        .f2{
            padding:30px;
            background: #fff;
            .channel{
                display: flex;
                flex-wrap: wrap;
                li{
                    margin-right:2%;
                    margin-bottom:20px;
                    width:31%;
                    padding:15px;
                    box-sizing: border-box;
                    background: #F9F9F9;
                    border-radius: 6px;
                    border: 1px solid #F4F3F3;
                    /deep/ .el-checkbox__label{
                        font-weight: 500;
                        color: #333333;
                    }
                    .ft{
                        height:45px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #777777;
                        line-height: 16px;
                        span{
                            color:#3373FE;
                        }
                    }
                    .uploads{
                        height:145px;
                        padding:15px 15px;
                        padding-left:30px;
                        background: #fff;
                        /deep/.avatar-uploader{
                            width:80px;
                            height:80px;
                        }
                        p{
                            display: flex;
                            margin-bottom:30px;
                           /deep/ .el-input__inner{
                               border-radius:8px;
                               width:100px;
                               background: #F6F6F9;
                           }
                            span{
                                font-size: 12px;
                                font-weight: 400;
                                color: #777777;
                            }
                            .shili{
                                margin-left:15px;
                                color:#3373FE;
                            }
                        }
                    }
                    .tent{
                        display: flex;
                        flex-direction:column;
                        justify-content: center;
                        height:145px;
                        // margin-top:15px;
                        background: #fff;
                        text-align: center;
                        .ic{
                            font-size:28px;
                            color:#327EFF
                        }
                        .t{
                            font-size: 12px;
                            font-weight: 400;
                            color: #777777;
                        }
                        .text{
                            font-size: 12px;
                            font-weight: 400;
                            color: #3373FE;
                        }
                    }
                }
            }
            .xuni{
                padding:30px 0;
                margin-top:15px;
                margin-left:25px;
                background: rgba(50, 126, 255, 0.06);
                border-radius: 7px;
                .el-form{
                    width:40%;
                }
                /deep/.el-input__inner{
                    background: #fff;
                }
                /deep/ .avatar-uploader{
                    background: #fff;
                }
                /deep/ .el-textarea__inner{
                    border:0px;
                    border-radius: 10px;
                }
            }
            .tabTitle{
                margin-top:15px;
                // margin-bottom:6px;
                padding:8px 30px;
                // background: rgba(50, 126, 255, 0.1);
                border-radius: 4px 4px 0 0;
                border: 1px solid #DADADA;
                border-bottom:0;
                display: flex;
                justify-content: space-between;
                /deep/ .el-button{
                    border: 1px solid #327EFF;
                    font-size: 12px;
                    font-weight: 400;
                    color: #327EFF;
                    // background: #EAF2FF;
                }
                p{
                    font-size: 16px;
                    font-weight: 500;
                    color: #333940;
                    span{
                        color:#327EFF;
                    }
                }
            }
            .addyhq{
                margin-top:15px;
                display: flex;
                align-items: center;
            }
            /deep/ .el-checkbox__inner{
                border-radius: 50%;
            }
            /deep/ .el-tag{
                border-radius: 30px;
                margin-right:10px;
                margin-bottom:10px;
            }
        }
    }
    .colorL{
        // padding:15px;
        span{
            margin-right: 15px;
            border-radius: 6px;
            display: inline-block;
            width: 35px;
            height: 28px;
            background: #F8B753;
            &:nth-child(6n){
                margin-right:0;
            }
        } 
        
    }
    .selectBG{
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 58px;
        height: 36px;
        // padding:4px;
        border: 1px solid #D5D5D5;
        span{
            display: inline-block;
            width: 47px;
            height: 28px;
            background: #F8B753;
        }
    }
</style>